import { arrayOf, bool, func, string } from 'prop-types';
import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { Col, FormGroup, Label } from 'reactstrap';

import { countries as COUNTRIES, COUNTRY_CODE_TO_NAMES } from '../../constants';
import SingleSelect from '../../generic/SingleSelect';
import { countryShape, optionShape, productShape } from '../../prop-types';
import { genders as GENDERS } from '../../quotes/constants';
import filterBy from '../../utils/filter-by';

export const COUNTRIES_WITH_CODE_AND_NAME = COUNTRIES.map(
  ({ countryCode }) => ({
    code: countryCode,
    name: COUNTRY_CODE_TO_NAMES[countryCode],
  }),
);

const makeLoadOptions = (countryFilter, selectedProduct) =>
  async function loadOptions(filterValue) {
    const countryOptions = countryFilter(
      COUNTRIES_WITH_CODE_AND_NAME,
      selectedProduct,
    );
    return filterValue
      ? filterBy(countryOptions, filterValue, ['name'])
      : countryOptions;
  };

function NewProductFields({
  selectedProduct,
  countries,
  genders,
  onSelectionChange,
  pricing,
  onPricingChange,
  disablePricingUpdate,
  countryFilter,
}) {
  const hasGender = selectedProduct.overwriteGender;
  const priceOptions = selectedProduct.possiblePriceModels.map(unit => ({
    label: unit,
    value: unit,
  }));
  const loadOptions = makeLoadOptions(countryFilter, selectedProduct);

  return (
    <FormGroup row>
      {selectedProduct.possiblePriceModels && (
        <Col sm={4}>
          <FormGroup>
            <Label for="pricing">Price Model</Label>
            <SingleSelect
              value={pricing}
              options={priceOptions}
              readOnly={disablePricingUpdate || priceOptions.length <= 1}
              id="pricing"
              name="pricing"
              onChange={onPricingChange}
            />
          </FormGroup>
        </Col>
      )}
      <Col sm={4} key="Countries">
        <FormGroup>
          <Label> Countries </Label>
          <AsyncSelect
            isMulti
            cacheOptions
            defaultOptions
            key={selectedProduct.id}
            name="COUNTRIES"
            loadOptions={loadOptions}
            value={countries}
            onChange={onSelectionChange}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.code}
          />
        </FormGroup>
      </Col>
      {hasGender && (
        <Col sm={4} key="Genders">
          <FormGroup>
            <Label> Genders </Label>
            <Select
              isMulti
              cacheOptions
              defaultOptions
              options={GENDERS}
              value={genders}
              onChange={onSelectionChange}
              name="GENDERS"
            />
          </FormGroup>
        </Col>
      )}
    </FormGroup>
  );
}

NewProductFields.propTypes = {
  selectedProduct: productShape.isRequired,
  countries: arrayOf(countryShape),
  onPricingChange: func.isRequired,
  disablePricingUpdate: bool,
  pricing: string,
  genders: arrayOf(optionShape.isRequired),
  onSelectionChange: func.isRequired,
  countryFilter: func.isRequired,
};

NewProductFields.defaultProps = {
  pricing: '',
  disablePricingUpdate: false,
  countries: [],
  genders: [],
};

export default NewProductFields;
